import React from "react";
import { PropTypes } from "prop-types";
import { useI18n } from "../../i18n/useI18n";
import css from "../commonMagneticStyle.less";

const NoDataAvailable = ({ message }) => {
  const { tViews } = useI18n();
  return (
    <div
      className={
        `${css["no-data-widget"]} flex-main-content flex-items width-full`
      }
      data-cy="no-data-widget"
      aria-label={tViews("c360.tEmpty")}
    >
      <div className={"gray-box flex-items-center"}>
        <div className="no-data-text hbr-type-body2">
          {message || tViews("c360.tEmpty")}
        </div>
      </div>
    </div>
  );
};

NoDataAvailable.propTypes = {
  text: PropTypes.string,
  message: PropTypes.string,
};

export default NoDataAvailable;
